const { registerBlockType } = wp.blocks;
const { InspectorControls, PanelColorSettings,  BlockControls,  AlignmentToolbar, useBlockProps } = wp.blockEditor;
const { PanelBody, RangeControl, ToggleControl, SelectControl, TextControl } = wp.components; 
import { __experimentalBorderBoxControl as BorderBoxControl, __experimentalBoxControl as BoxControl, TabPanel, __experimentalUnitControl as UnitControl, BaseControl, __experimentalInputControl as InputControl, TextareaControl } from '@wordpress/components';
const { Fragment } = wp.element;
const { __ } = wp.i18n;
import FontIconPicker from '@fonticonpicker/react-fonticonpicker';
import {icons} from './lib/icons';
import {colors} from './lib/colors';

const BlockEdit = (props) => {
	const { attributes, setAttributes,clientId } = props;
	const{ uniqueid, iconv, iconWidth, iconbg, iconhbg, border, borderradius, margins, paddings, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, iconColor, iconhColor, shadowColor, bordertopradius, borderrightradius, borderbottomradius, borderleftradius, addclass, customcss }=attributes;
	setAttributes({ uniqueid: 'spiceblocksicon' +clientId.slice(0,8) });
    const blockclass='spice-blocks-icon';
	const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : '';
	const animationclass='wow animated '+attributes.durations+' '+attributes.animation;
	const displaydesktop=(hidedesktop == false) ? 'hide-desktop' : '';
	const displaytablet=(hidetablet == false) ? 'hide-tablet' : '';
	const displaymobile=(hidemobile == false) ? 'hide-mobile' : '';
	const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
	
	function seticonColor(value) {
		setAttributes({iconColor:value});
	}
	function seticonhColor(value) {
		setAttributes({iconhColor:value});
	}
	function seticonBg(value) {
		setAttributes({iconbg:value});
	}
	function seticonhBg(value) {
		setAttributes({iconhbg:value});
	}
	function setShadowColor(value) {
		setAttributes({shadowColor:value});
	}

	
	const blockProps = useBlockProps();

    const SpiceColorTabPanel = () => (
		<TabPanel
			className="color-tab-panel"
			activeClass="active-tab"
			tabs={[
				{
					name: 'normal',
					title: __('Normal','spice-blocks'),
					className: 'tab-one',
					content:<PanelColorSettings  initialOpen={open}
						
						colorSettings={[
							{	
								value: iconColor,
								clearable: true,
								onChange: seticonColor,
								label: __('Icon Color:','spice-blocks'),
								
							},
							{
								value: iconbg,
								clearable: true,
								onChange: seticonBg,
								label: __('Background Color:','spice-blocks')
							},
						]}
						className={'spice-blocks-normal-button'}
					/>
				},
				{
					name: 'hover',
					title: __('Hover','spice-blocks'),
					className: 'tab-two',
					content:<PanelColorSettings  initialOpen={open}
						
						colorSettings={[
							{	
								value: iconhColor,
								onChange: seticonhColor,
								label: __('Icon Color:','spice-blocks'),
								
							},
							{
								value: iconhbg,
								onChange: seticonhBg,
								label: __('Background Color:','spice-blocks')
							},
						]}
						className={'spice-blocks-hover-button'}
					/>
				},
			]}
		>
		{ ( tab ) => <p>{ tab.content }</p> }
		</TabPanel>
	);
	
	const bordertop=(border.top != undefined) ? `${border.top.width} ${border.top.style} ${border.top.color}` : null;
	const borderright=(border.right != undefined) ? `${border.right.width} ${border.right.style} ${border.right.color}` : null;
	const borderbottom=(border.bottom != undefined) ? `${border.bottom.width} ${border.bottom.style} ${border.bottom.color}` : null;
	const borderleft=(border.left != undefined) ? `${border.left.width} ${border.left.style} ${border.left.color}` : null;
	
	var urlfontawesome=plugin.pluginpath+'assets/js/fontawesome.js';
	let linkfontawesome = document.createElement('script');
	linkfontawesome.src=urlfontawesome;
	jQuery('iframe').contents().find('head').append(linkfontawesome);

	return(
		<Fragment>
			<style dangerouslySetInnerHTML={{
			  __html: [
			     `.spice-blocks-icon#${uniqueid} i{
						color: ${iconColor};
						background-color:${iconbg};
						font-size: ${iconWidth}px;
						border: ${border.width} ${border.style} ${border.color};
						border-top:${bordertop};
						border-right:${borderright};
						border-bottom:${borderbottom};
						border-left:${borderleft};
						border-radius: ${bordertopradius} ${borderrightradius} ${borderbottomradius} ${borderleftradius};	
						box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
						margin: ${margins.top} ${margins.right} ${margins.bottom} ${margins.left};
						padding: ${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left};
						box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
					}
					.spice-blocks-icon#${uniqueid} i:hover{
						color: ${iconhColor};
						background-color:${iconhbg};
					}
					.spice-blocks-icon#${uniqueid}{
						animation-delay: ${delay}ms;
					}
					${customcss}`					
			    ].join('\n')
			  }}>
			</style>

			<InspectorControls>
				<PanelBody initialOpen={false} title={__('General Settings','spice-blocks')}>
					
			        <FontIconPicker
						theme={"default spiceblocksicon "+uniqueid}																				
						icons={icons}
						value={iconv}
						onChange={(val) => setAttributes({ iconv: val })}
			        />
			        <RangeControl 
			            label={__('Width(px)','spice-blocks')}
			           	value={iconWidth}
			            onChange={(newtext) => setAttributes({ iconWidth: newtext })}
			            min={0}
						max={500}

			        />
			        <BorderBoxControl
			        	colors={colors}
			            label={ __( 'Border' ,'spice-blocks') }
			            onChange={(newtext) => setAttributes({ border: newtext })}
			            value={ border }
			        />
					<BaseControl className="spice-blocks-border-radius" label={__('Border Radius','spice-blocks')} __nextHasNoMarginBottom={ true }>
				        <UnitControl className={"border-radius-top"} onChange={ (newtext) => setAttributes({ bordertopradius: newtext }) } value={ bordertopradius } placeholder={"Top"} />

				        <UnitControl className={"border-radius-right"} onChange={ (newtext) => setAttributes({ borderrightradius: newtext }) } value={ borderrightradius } placeholder={"right"} />			        
				        
				        <UnitControl className={"border-radius-left"} onChange={ (newtext) => setAttributes({ borderleftradius: newtext }) } value={ borderleftradius } placeholder={"left"}/>

				        <UnitControl className={"border-radius-bottom"}  onChange={ (newtext) => setAttributes({ borderbottomradius: newtext }) } value={ borderbottomradius }  placeholder={"bottom"}/>	       
			        </BaseControl>
			        <BoxControl 
						label={__('Margin','spice-blocks')}
						inputProps={{ min: -300 }}
						values={margins}
						sides={['top', 'bottom','left','right']}
						allowReset={false}
						units={[]}
						onChange={(newValue) =>
							setAttributes({
								...margins,
								margins: {
									top: newValue.top,
									left: newValue.left,
									right: newValue.right,
									bottom: newValue.bottom,
								},
							})
						}
					/>
          			<BoxControl
						values={paddings}
						label={__('Padding','spice-blocks')}
						units={[]}
						allowReset={false}
						onChange={(newValue) =>
							setAttributes({
								...paddings,
								paddings: {
									top: newValue.top,
									left: newValue.left,
									right: newValue.right,
									bottom: newValue.bottom,
								},
							})
						}
					/>			        

					<PanelBody initialOpen={false} title={__('Display','spice-blocks')} className={'spice-panel-edit'}>					
						<ToggleControl
							label={__('Enable/Disable on Desktop','spice-blocks')}
							checked={hidedesktop}
							onChange={(newval) => setAttributes({ hidedesktop: newval })}
						/>
						<ToggleControl
							label={__('Enable/Disable on Tablet','spice-blocks')}
							checked={hidetablet}
							onChange={(newval) => setAttributes({ hidetablet: newval })}
						/>
						<ToggleControl
							label={__('Enable/Disable on Mobile','spice-blocks')}
							checked={hidemobile}
							onChange={(newval) => setAttributes({ hidemobile: newval })}
						/>
					</PanelBody>

					<PanelBody initialOpen={false} title={__('Animation Effects','spice-blocks')} className={'spice-panel-edit'}>
		        		<SelectControl
				            label={__('Animation','spice-blocks')}
				            value={ animation }
				            options={ [
				            	{ label: __('None','spice-blocks'), value: ' ' },
                                { label: __('Bounce','spice-blocks'), value: 'bounce' },
                                { label: __('Flash','spice-blocks'), value: 'flash' },
                                { label: __('Pulse','spice-blocks'), value: 'pulse' },
                                { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
                                { label: __('Shake','spice-blocks'), value: 'shake' },
                                { label: __('Swing','spice-blocks'), value: 'swing' },
                                { label: __('Tada','spice-blocks'), value: 'tada' },
                                { label: __('Wobble','spice-blocks'), value: 'wobble' },
                                { label: __('Jello','spice-blocks'), value: 'jello' },
                                { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
                                { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
                                { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
                                { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
                                { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
                                { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
                                { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
                                { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
                                { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
                                { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
                                { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
                                { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
                                { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
                                { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
                                { label: __('Flip','spice-blocks'), value: 'flip' },
                                { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
                                { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
                                { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
                                { label: __('RollIn','spice-blocks'), value: 'rollIn' },
                                { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
                                { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
                                { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
                                { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
                                { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
                                { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
                                { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
                                { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
                                { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
                                { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
                                { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
                                { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
                                { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' },
			            	] }
		            		onChange={ (newtext) => setAttributes({ animation: newtext }) }					  
		        		/>  
				        { animation != '' && (
				        	<>
						        <SelectControl
						            label={__('Durations','spice-blocks')}
						            value={ durations }
						            options={ [
						            	{ label: __('Normal','spice-blocks'), value: ' ' },
						                { label: __('Slow','spice-blocks'), value: 'slow' },
						                { label: __('Fast','spice-blocks'), value: 'fast' },
						            ] }
						            onChange={ (newtext) => setAttributes({ durations: newtext }) }					  
						        />  
					        	<TextControl
						            label={__('Delay(ms)','spice-blocks')}			    
						            value={delay}
			        				onChange={(newtext) => setAttributes({ delay: newtext })}
							    />
							</>
							)
						}
					</PanelBody>
			    </PanelBody>

			    <PanelBody initialOpen={false} title={ __('Box Shadow','spice-blocks') }>	
					<RangeControl 
						label={ __('Horizontal Shadow(px)','spice-blocks') }			    
					    value={ hshadow}
					    onChange={(newtext) => setAttributes({ hshadow: newtext })}
						min={0}
						max={100}
					/>
					<RangeControl 
						label={ __('Vertical Shadow(px)','spice-blocks') }			    
					    value={ vshadow}
			        	onChange={(newtext) => setAttributes({ vshadow: newtext })}
						min={0}
						max={100}
					/>	
					<RangeControl 
						label={ __('Blur Shadow(px)','spice-blocks') }			    
					    value={ blurshadow}
			        	onChange={(newtext) => setAttributes({ blurshadow: newtext })}
						min={0}
						max={100}
					/>
					<PanelColorSettings  initialOpen={true}
						className='spice-block-section-bg-color'
						title={ __('Box Shadow Color','spice-blocks') }
						colorSettings={[
							{
							value: shadowColor,
							onChange: setShadowColor,
							label: __('Box Shadow:','spice-blocks')
							},
						]}
					/>
				</PanelBody>

			    <PanelBody initialOpen={false} title={__('Color & Background Settings','spice-blocks')} className={"spice-blocks-dual-color"} >
			    	<div {...blockProps} >
						{SpiceColorTabPanel()}
					</div>				   
				</PanelBody>

				<PanelBody initialOpen={false} title={__('Additional Settings','spice-blocks')}>
                    <InputControl
                        label={__('Additional Class','spice-blocks')}
                        value={ addclass }
                        onChange={ (userVal)=> setAttributes({addclass:userVal}) }
                    />
                    <TextareaControl
                        label={__('Custom CSS','spice-blocks')}
                        value={ customcss }
                        onChange={ (userVal)=> setAttributes({customcss:userVal}) }
                    />
                </PanelBody>

			</InspectorControls>

			<BlockControls>
				<AlignmentToolbar
					value={attributes.textAlignment}
					onChange={(newalign) => setAttributes({ textAlignment: newalign })}
				/>			
			</BlockControls>

			<div id={uniqueid} className={`${blockclass} ${alignmentClass} ${animationclass} ${displayclass} ${addclass}`}>
				<i className={iconv}></i>				
			</div>
			
		</Fragment>
	);
}
 
registerBlockType('spice-blocks/spice-icon', {
	title: __('Icon','spice-blocks'),
	category: 'spice-blocks',
	icon: <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><g><ellipse stroke="#09A223" stroke-width="2" ry="9.87913" rx="9.87913" id="svg_9" cy="12.00228" cx="12.51808" fill="none"></ellipse><path stroke="null" id="svg_11" d="m22.51911,1.3706l-1.98122,-1.12429c-0.49987,-0.28338 -1.15853,-0.14699 -1.4735,0.30441l-0.78091,1.12219l3.79016,2.14928l0.78153,-1.12167c0.31377,-0.45194 0.16402,-1.04717 -0.33605,-1.32992l0,0zm-10.98023,9.99757l3.79037,2.14925l6.17767,-8.87906l-3.79217,-2.14982l-6.17586,8.87962l0,0zm-0.57898,2.73071l-0.08372,2.01876l1.97818,-0.94469l1.83829,-0.87633l-3.65669,-2.07477l-0.07607,1.87703l0,0l0,0z" fill="#09A223"></path></g></svg>,
	keywords: ['Spice Icon', 'icon', 'Icon'],
	example: {
        'attributes' : {
            'mode' : 'preview',
        }
    },
	attributes: {
		uniqueid:{
			type:'string',
		},
		iconv:{
			type:'string',
			default:'fa fa-address-book',
		},
		iconWidth: {
			type: 'number',
		},
		textAlignment: {
			type: 'string',
			default:'left'
		},
		bordertopradius:{
	    	type: 'string',
	    	default: '0px'
	    },
	    borderrightradius:{
	    	type: 'string', 
	    	default: '0px' 
	    },
	    borderbottomradius:{
	    	type: 'string',
	    	default: '0px'
	    },
	    borderleftradius:{
	    	type: 'string',
	    	default: '0px'
	    },
        border: {
            type: 'object',
            default: {
                color: '#09A223',
                style: 'solid',
                width: '2px',        
            },
        },
        margins: {
	        default: {
	            top: '0px',
	            left: '0px',
	            right: '0px',
	            bottom: '0px'
	        }
    	},
		paddings:{
			type: 'object',
		    default: {
		        top: '12px',
		        left: '12px',
		        right: '12px',
		        bottom: '12px',
		      },
		},
    	hshadow: {
			type: 'number',
			default: 0
		},
		vshadow: {
			type: 'number',
			default: 0
		},
		blurshadow: {
			type: 'number',
			default: 0
		},
		hidedesktop:{
	    	type: 'boolean',
			default: true
	    },
	    hidetablet:{
	    	type: 'boolean',
			default: true
	    },
	    hidemobile:{
	    	type: 'boolean',
			default: true
	    },
		animation:{
	    	type:'string',
	    	default:''
	    },
	    durations:{
	    	type:'string',
	    	default:' '
	    },
	    delay:{
	    	type:'string',
	    },
	    iconColor:{
	    	type:'string',
	    	default:'#000'
	    },
	    iconhColor:{
	    	type:'string',
	    },
	    iconhbg:{
	    	type:'string',
	    	default:'#09A223'
	    },
	    iconbg:{
	    	type:'string',
	    	default:'#fff'
	    },
	    shadowColor:{
	    	type:'string',
	    	default:'#000'
	    },
	    addclass:{
	    	type:'string',
	    },
	    customcss:{
	    	type:'string',
	    }
	},
	supports: {
		align: ['wide', 'full']
	},
	edit: BlockEdit,
	save: (props) => { 
		const { attributes } = props;
		const{uniqueid, iconv, iconWidth, iconbg, iconhbg, border, borderradius, margins, paddings, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, iconColor, iconhColor, shadowColor, bordertopradius, borderrightradius, borderbottomradius, borderleftradius, addclass, customcss}=attributes;

		const blockclass='spice-blocks-icon';
		const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : '';
		const animationclass='wow animated '+attributes.durations+' '+attributes.animation;
		const displaydesktop=(hidedesktop == false) ? 'hide-desktop' : '';
		const displaytablet=(hidetablet == false) ? 'hide-tablet' : '';
		const displaymobile=(hidemobile == false) ? 'hide-mobile' : '';
		const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
		
		const bordertop=(border.top != undefined) ? `${border.top.width} ${border.top.style} ${border.top.color}` : null;
		const borderright=(border.right != undefined) ? `${border.right.width} ${border.right.style} ${border.right.color}` : null;
		const borderbottom=(border.bottom != undefined) ? `${border.bottom.width} ${border.bottom.style} ${border.bottom.color}` : null;
		const borderleft=(border.left != undefined) ? `${border.left.width} ${border.left.style} ${border.left.color}` : null;
		
		return (
			<>
				<style dangerouslySetInnerHTML={{
				  __html: [
				     `.spice-blocks-icon#${uniqueid} i{
						color: ${iconColor};
						background-color:${iconbg};
						font-size: ${iconWidth}px;
						border: ${border.width} ${border.style} ${border.color};
						border-top:${bordertop};
						border-right:${borderright};
						border-bottom:${borderbottom};
						border-left:${borderleft};
						border-radius: ${bordertopradius} ${borderrightradius} ${borderbottomradius} ${borderleftradius};	
						box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
						margin: ${margins.top} ${margins.right} ${margins.bottom} ${margins.left};
						padding: ${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left};
						box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
					}
					.spice-blocks-icon#${uniqueid} i:hover{
						color: ${iconhColor};
						background-color:${iconhbg};
					}
					.spice-blocks-icon#${uniqueid}{
						animation-delay: ${delay}ms;
					}
						${customcss}`					
				    ].join('\n')
				  }}>
				</style>

				<div id={uniqueid} className={`${blockclass} ${alignmentClass} ${animationclass} ${displayclass} ${props.attributes.className} ${addclass}`}>
					<i className={iconv} ></i>					
				</div>
			</>
		);
	}
});